import classNames from "classnames";
import PropTypes from "prop-types";
import { forwardRef } from "react";

import classes from "./label.module.scss";

const H1 = "h1";
const H2 = "h2";
const H3 = "h3";
const H4 = "h4";
const H5 = "h5";
const H6 = "h6";
//const P = "p";

const Label = forwardRef(function Label(
  {
    tag,
    size,
    color,
    weight,
    align,
    onClick,
    className,
    style: customStyle,
    children,
    ...props
  },
  ref
) {
  const style = {
    textAlign: align,
    ...customStyle,
  };

  const handleClick = (event) => {
    event.currentTarget.blur();
    onClick && onClick(event);
  };

  switch (tag) {
    case H1:
      return (
        <h1
          onClick={handleClick}
          className={classNames(
            classes.label,
            classes[size],
            classes[color],
            classes[weight],
            className
          )}
          style={style}
          {...props}
          ref={ref}
        >
          {children}
        </h1>
      );
    case H2:
      return (
        <h2
          onClick={handleClick}
          className={classNames(
            classes.label,
            classes[size],
            classes[color],
            classes[weight],
            className
          )}
          style={style}
          {...props}
          ref={ref}
        >
          {children}
        </h2>
      );
    case H3:
      return (
        <h3
          onClick={handleClick}
          className={classNames(
            classes.label,
            classes[size],
            classes[color],
            classes[weight],
            className
          )}
          style={style}
          {...props}
          ref={ref}
        >
          {children}
        </h3>
      );
    case H4:
      return (
        <h4
          onClick={handleClick}
          className={classNames(
            classes.label,
            classes[size],
            classes[color],
            classes[weight],
            className
          )}
          style={style}
          {...props}
          ref={ref}
        >
          {children}
        </h4>
      );
    case H5:
      return (
        <h5
          onClick={handleClick}
          className={classNames(
            classes.label,
            classes[size],
            classes[color],
            classes[weight],
            className
          )}
          style={style}
          {...props}
          ref={ref}
        >
          {children}
        </h5>
      );
    case H6:
      return (
        <h6
          onClick={handleClick}
          className={classNames(
            classes.label,
            classes[size],
            classes[color],
            classes[weight],
            className
          )}
          style={style}
          {...props}
          ref={ref}
        >
          {children}
        </h6>
      );
    default:
      return (
        <p
          onClick={handleClick}
          className={classNames(
            classes.label,
            classes[size],
            classes[color],
            classes[weight],
            className
          )}
          style={style}
          {...props}
          ref={ref}
        >
          {children}
        </p>
      );
  }
});

Label.sizes = ["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"];
Label.colors = ["default", "primary", "secondary", "navbar"];
Label.weights = ["bold", "semibold", "normal"];
Label.tags = ["h1", "h2", "h3", "h4", "h5", "h6", "p"];
Label.align = ["start", "center", "end"];

Label.propTypes = {
  tag: PropTypes.oneOf(Label.tags).isRequired,
  size: PropTypes.oneOf(Label.sizes),
  color: PropTypes.oneOf(Label.colors).isRequired,
  weight: PropTypes.oneOf(Label.weights).isRequired,
  align: PropTypes.oneOf(Label.align).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

Label.defaultProps = {
  tag: "p",
  color: "default",
  weight: "normal",
  align: "center",
};

export default Label;
